import { createListenerMiddleware } from '@reduxjs/toolkit'

import { SIDEBARS } from '@/defs/view'
import { setSidebarsCookie } from '@/utils/cookieUtil'

import { type ReduxRootState } from '../store'

import { getSidebars } from './slice'

export const viewListener = createListenerMiddleware()

viewListener.startListening({
  effect: (_, { getState }) => setSidebarsCookie(getSidebars((getState() as ReduxRootState).view)),
  predicate: (_, currentState, originalState) => {
    const curr = getSidebars((currentState as ReduxRootState).view)
    const prev = getSidebars((originalState as ReduxRootState).view)

    return SIDEBARS.some((sidebar) => curr[sidebar] !== prev[sidebar])
  },
})
